import { database } from "../firebase";
import { ref, onValue, update, remove } from "firebase/database";

export function subscribeToAvailableUsers(callback, errorCallback) {
    // We query a lightweight endpoint for active users instead of the entire scans tree
    const usersRef = ref(database, "data/users/activeUsers");
    const unsubscribe = onValue(usersRef, (snapshot) => {
        let userIDs = [];
        if (snapshot.exists()) {
            userIDs = Object.keys(snapshot.val());
        }
        callback(userIDs);
    }, errorCallback);
    
    return () => { unsubscribe(); };
}

export function subscribeToAdmins(callback) {
    const adminsRef = ref(database, "data/settings/admins");
    const unsubscribe = onValue(adminsRef, (snapshot) => {
        if (snapshot.exists()) {
            const data = snapshot.val();
            const list = Object.keys(data).filter((k) => data[k] === true);
            callback(list);
        } else {
            callback([]);
        }
    });
    return () => { unsubscribe(); };
}

export async function addAdmin(sanitizedEmail) {
    return update(ref(database, "data/settings/admins"), {
        [sanitizedEmail]: true,
    });
}

export async function removeAdmin(sanitizedEmail) {
    return remove(ref(database, `data/settings/admins/${sanitizedEmail}`));
}
